import React from 'react';
import { useLoggedOutAthletePageContext } from '../../state/LoggedOutAthletePageContext';

import styles from './FollowAthleteCTA.module.scss';

const FollowAthleteCTA = () => {
  const { state, t } = useLoggedOutAthletePageContext();
  const { athleteData } = state;
  const { athlete } = athleteData;

  return (
    <h1 className={styles.followAthleteCTA}>
      {t('follow_athlete', { athlete_name: athlete.firstname })}
    </h1>
  );
};

export default FollowAthleteCTA;
